<template>
  <div class="header">
    <div class="header-left">
      <button v-if="isMobile" class="mobile-menu-button" @click="toggleSidebar">
        <ion-icon name="menu-outline"></ion-icon>
      </button>
      <h1>{{ title }}</h1>
    </div>
    <div class="header-actions">
      <button v-if="showSubscribeButton && !subscription" class="subscribe-button" @click="goSuscribirse">
        <h3>✨ Suscribirse ✨</h3>
      </button>
      <div class="hamburger-menu-container">
        <button class="hamburger-menu-button" @click="toggleHamburgerMenu">
          <ion-icon :name="isMobile ? 'ellipsis-vertical-outline' : 'menu-outline'"></ion-icon>
        </button>
        <div v-if="showHamburgerMenu" class="hamburger-menu">
          <router-link to="/" class="menu-item" @click="closeHamburgerMenu">
            <ion-icon name="chatbox-outline"></ion-icon>
            <span>Chat</span>
          </router-link>

          <router-link v-if="hasRedaccionPermission" to="/modo-redaccion" class="menu-item" @click="closeHamburgerMenu">
            <ion-icon name="create-outline"></ion-icon>
            <span>Modo Redacción</span>
          </router-link>

          <!-- <router-link v-if="isAdmin" to="/perfil#whatsapp" class="menu-item" @click="closeHamburgerMenu"> -->
          <router-link to="/perfil#whatsapp" class="menu-item" @click="closeHamburgerMenu">
            <ion-icon name="logo-whatsapp" />
            <span>Usar por Whatsapp</span>
          </router-link>

          <!-- <router-link v-if="isAdmin" to="/perfil#telegram" class="menu-item" @click="closeHamburgerMenu"> -->
          <router-link to="/perfil#telegram" class="menu-item" @click="closeHamburgerMenu">
            <ion-icon name="send" />
            <span>Usar por Telegram</span>
          </router-link>

          <router-link to="/perfil" class="menu-item" @click="closeHamburgerMenu">
            <ion-icon name="person-outline"></ion-icon>
            <span>Mi Perfil</span>
          </router-link>

          <router-link to="/suscribirse" class="menu-item" @click="closeHamburgerMenu">
            <ion-icon name="card-outline"></ion-icon>
            <span>Suscripción</span>
          </router-link>

          <router-link to="/preguntas-publicas" class="menu-item" @click="closeHamburgerMenu">
            <ion-icon name="chatbubbles-outline"></ion-icon>
            <span>Navegar preguntas públicas</span>
          </router-link>

          <a class="menu-item" @click="goToContact">
            <ion-icon name="mail-outline"></ion-icon>
            <span>Contacto</span>
          </a>

          <button class="menu-item" @click="confirmLogout">
            <ion-icon name="log-out-outline"></ion-icon>
            <span>Salir</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderMenuComponent',
  props: {
    title: {
      type: String,
      required: true
    },
    permissions: {
      type: Array,
      default: () => []
    },
    subscription: {
      type: Object,
      default: null
    },
    showSubscribeButton: {
      type: Boolean,
      default: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-sidebar', 'logout', 'show-toast'],
  data() {
    return {
      showHamburgerMenu: false
    };
  },
  computed: {
    hasRedaccionPermission() {
      return this.permissions.includes('redaccion:data');
    },
    isAdmin() {
      return this.permissions.includes('admin:data');
    }
  },
  methods: {
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    },
    goSuscribirse() {
      this.$router.push({ name: "suscribirse" });
    },
    toggleHamburgerMenu() {
      this.showHamburgerMenu = !this.showHamburgerMenu;

      // Close menu when clicking outside
      if (this.showHamburgerMenu) {
        setTimeout(() => {
          document.addEventListener('click', this.closeHamburgerMenuOnClickOutside);
        }, 0);
      }
    },
    closeHamburgerMenu() {
      this.showHamburgerMenu = false;
      document.removeEventListener('click', this.closeHamburgerMenuOnClickOutside);
    },
    closeHamburgerMenuOnClickOutside(event) {
      // Check if click is outside the menu
      if (!event.target.closest('.hamburger-menu-container')) {
        this.showHamburgerMenu = false;
        document.removeEventListener('click', this.closeHamburgerMenuOnClickOutside);
      }
    },
    goToContact() {
      window.open('https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit', '_blank');
      this.closeHamburgerMenu();
    },
    confirmLogout() {
      this.closeHamburgerMenu();
      this.$emit('logout');
    }
  },
  beforeUnmount() {
    // Clean up event listener
    document.removeEventListener('click', this.closeHamburgerMenuOnClickOutside);
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background-color: rgba(230, 230, 230, 0.9);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-grow: 1;
  min-width: 0;
  /* Permite que el contenedor se encoja */
  overflow: hidden;
}

.header h1 {
  font-size: 18px;
  margin: 0;
  color: #333;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  /* Usa el espacio disponible */
  min-width: 0;
  /* Permite que el h1 se encoja */
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  /* Evita que se encoja */
}

.mobile-menu-button {
  background: none;
  border: none;
  color: #333;
  font-size: 32px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.subscribe-button {
  border: none;
  background-color: #a1344e;
  color: #f0f0f0;
  font-size: 14px;
  padding: 8px 24px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-right: 24px;
  flex-shrink: 0;
}

.subscribe-button h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.subscribe-button:hover {
  background-color: #b71c1c;
}

.hamburger-menu-container {
  position: relative;
  display: inline-block;
}

.hamburger-menu-button {
  background: none;
  border: none;
  color: #333;
  font-size: 32px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hamburger-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: rgb(250, 250, 250);
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  z-index: 10;
  min-width: 250px;
  padding: 5px 0;
  margin-top: 5px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  color: #333;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;
  text-decoration: none;
}

.menu-item:hover {
  background-color: rgba(161, 52, 78, 0.2);
}

.menu-item ion-icon {
  margin-right: 10px;
  font-size: 22px;
  color: #a1344e;
  flex-shrink: 0;
}

.menu-item span {
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  .header {
    padding: 12px 15px;
    width: 100%;
  }

  .header-left {
    flex-shrink: 1;
    min-width: 0;
    /* Permite que se encoja correctamente */
    overflow: hidden;
  }

  .header h1 {
    font-size: 16px;
    flex: 1;
    min-width: 0;
    /* Permite que se encoja correctamente */
  }

  .header-actions {
    flex-shrink: 0;
  }

  .subscribe-button {
    padding: 6px;
    margin-right: 0;
    margin-left: 12px;
  }

  .subscribe-button h3 {
    font-size: 14px;
  }

  .hamburger-menu {
    min-width: 220px;
  }

  .hamburger-menu-button {
    font-size: 28px;
  }

  .menu-item {
    padding: 10px 12px;
  }

  .menu-item span {
    font-size: 14px;
  }
}
</style>
